import type { DeliveryScopeType } from "@/lib/deliveries/config"

export const agentIntegrationStatusesTenantQueryKey = (tenantId: string) => [
  "agent-integration-statuses",
  tenantId,
] as const

export const agentIntegrationStatusesQueryKey = (
  tenantId: string,
  scopeType: DeliveryScopeType,
  agentIds?: string[],
) => [
  ...agentIntegrationStatusesTenantQueryKey(tenantId),
  scopeType,
  ...(agentIds ? [agentIds.toSorted()] : []),
] as const
